<ub-button-list>
<ng-container *ngFor="let item of filteredButtons$ | async">
  <a mat-flat-button *ngIf="isLinkAction(item)"
                     color="{{item.color}}"
                     [routerLink]="item.link | async"
                     [queryParams]="item.queryParams ?? {}"
                     [disabled]="disabled || processing">{{ item.label }}</a>

  <button mat-flat-button *ngIf="isButtonAction(item)"
                          color="{{item.color}}"
                          (click)="item.click()"
                          type="button"
                          [disabled]="disabled || processing">{{ item.label }}</button>
</ng-container>
</ub-button-list>
